import Card from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
// import { Input, Padding } from '@mui/icons-material';
import { useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { useContext } from 'react';
import {Todocontext} from "../context/todoscontext";
// import {Toastcontext} from "../context/toastcontext"
//حق ايقونه الحذف
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

       
         
// حق التعديل
import TextField from '@mui/material/TextField';
// import { Details, Flood } from '@mui/icons-material';
import { Toastcontext } from '../context/toastcontext';
// export default function Todo({todo,handalcheke} ){//todos,===>البروب الواصل من الليست 
//   function  handalchekee(){
//     handalcheke(todo.id); //todo.id==> cheekالذي هو الااب عشان يعرف من هو الاايدي الذي فعلته parent سيتم ارساله الى 
//   }
export default function Todo({todo} ){//هاذا عند تحويل الى حل كونتكس تقدر تستدعي وتعدل 
  const{todos,settodos}=useContext(Todocontext)
  const{Showhidetoast}=useContext(Toastcontext)//contextحق الرساله تم اضافه والتعديل
  const [showdeletedialog,setdeletedialog]=useState(false)//عرض الواجهه في حاله تم ضغط على الحذف
  const [showeditetodos,seteditodos]=useState(false)
  const [updtetodo,setupdtetodo]=useState({tittle:todo.tittle,detals:todo.detals})
 
  const open=true
 
//{ even function hand}
  function  handalcheke(){    
    const updatetodoid=todos.map((t)=>{
      if(t.id==todo.id){
        if(t.iscomplet==true){
          t.iscomplet=false
        }else{
          t.iscomplet=true
        }
       
      }
       return t;
      
    });
    settodos(updatetodoid);
    Showhidetoast("تم التعديل بنجاح ")
     localStorage.setItem("toodos",JSON.stringify(updatetodoid))//عند التعديل الصح يبقى صح عند التحديث
    }
 
  function handclosedelet(){
    setdeletedialog(false);
  }
  function handdeletetodo(){
   setdeletedialog(true);
   
  }  
  function handdeleteconfirm(){
    const updatetodos=todos.filter((c)=>{
      if(c.id==todo.id){
        return false;//هاذا لاتردهاش 
      }else{
        return true;//ردلي الباقي 
      }
      
      
    });
    settodos(updatetodos);
    Showhidetoast("تم الحذف بنجاح")
      localStorage.setItem("toodos",JSON.stringify(updatetodos))//عند الحذف وفعلت تحديث يبقى محذوف
    //  alert ("تم الحذف")
  }
  function hanupdateconfrim(){
    // alert ("jjjjjjj")
    const updatetodos=todos.map((t)=>{
      if(t.id==todo.id){
        return {...t,tittle: updtetodo.tittle,detals: updtetodo.detals};
      }else{
        return t;
      }
    })
    settodos(updatetodos);    
    handcloseEdete(false);//عند اهمس اوك يغلق النافذه 
    Showhidetoast("تم تعديل بنجاح")
     localStorage.setItem("toodos",JSON.stringify(updatetodos))//عند تعديل وعملت تحديث يبقى على ماعدلت

  }
  function handEdatitodo(){
    // alert ("edite")
    seteditodos(true); 
   
  }
  function handcloseEdete(){
    seteditodos(false);
  }
  

  //{even function hsnd}
    return(
      
      <>
      
      {/* delete dailog */}
      <Dialog
        open={showdeletedialog}//فتح نافذه الحذف 
        onClose={()=>{
          handclosedelet()
        }}
        style={{direction:'rtl'}}
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" هل انت بالفعل تريد حذف المجله او الكتاب ؟"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           لايمكنك التراجع عن الحذف بعد اتمامه
          </DialogContentText>
        </DialogContent>
        <DialogActions>
           <Button onClick={()=>{handclosedelet()}}>اغلاق </Button>
          <Button  autoFocus onClick={()=>{handdeleteconfirm()}}> 
              نعم قم بحذفه  
          </Button>
        </DialogActions>
      </Dialog>
      {/* delete dailog */}

      {/* update dailog */}
       <Dialog
        open={showeditetodos}
        style={{direction:"rtl"}}
         onClose={handcloseEdete}
         >
       
        <DialogContent>
          <DialogContentText>
          هل انت متاكد من رغبتك في تعديل المهمه ؟
          </DialogContentText>
          <form
          
            id="subscription-form"
            >
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              name="tittle"
              label="title"
              type="text"
              fullWidth
              variant="standard"
              value={updtetodo.tittle}//القيمه الذي ادهخلها عند التعديل 
               onChange={(e)=>{//{عند الكتابه تضيف ماعدله في القيمه
              // settititeleedit(e.target.value)//يضيف الذي عدلناه  في القيمه 
              setupdtetodo({...updtetodo,tittle:e.target.value})//يضيف الذي عدلناه  في القيمه 
             }}


            />
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              name="detals"
              label="detals"
              type="text"
              fullWidth
              variant="standard"
               value={updtetodo.detals}//القيمه الذي ادهخلها عند التعديل 
               onChange={(e)=>{//{عند الكتابه تضيف ماعدله في القيمه
              // settititeleedit(e.target.value)//يضيف الذي عدلناه  في القيمه 
              setupdtetodo({...updtetodo,detals:e.target.value})//يضيف الذي عدلناه  في القيمه 
             }}

            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{handcloseEdete()}} >  اغلاق </Button>
          <Button type="submit" onClick={()=>{hanupdateconfrim()}}>
            بتاكيد
          </Button>
        </DialogActions>
      </Dialog>
      {/* edite dailog */}
<Card style={{backgroundColor:"blue", color:"white",textAlign:"right",marginTop:"10px",}}>   
    
    <Grid
    className="toodocard"
    container spacing={2} 
    style=
    {{
      margin:"10px",
      backgroundColor:"blue",
      // display:"flex",
      
      

      }}>
        <Grid size={{ xs: 8, md: 8 }} style={{backgroundColor:"blue" ,textAlign:"right"}}>
          <Typography variant='h2' style={{textDecoration:todo.iscomplet==true?"line-through":"none",color:todo.iscomplet==true?"green":"white"}}> {todo.tittle}</Typography>
          <Typography variant='h6' style={{textDecoration:todo.iscomplet==true?"line-through":"none",color:todo.iscomplet==true?"green":"white"}}> {todo.detals}</Typography>{/* detals==>يعرض الديتالس حق المصفوفه */}
        </Grid>
        <Grid size={{
           xs: 4, md: 8}}
            style=
            {{backgroundColor:"blue",
              //  direction:"rtl",
            
            display:"flex",
            textAlign:"left",
            // alignItems:"flex-start",
            
             justifyContent:"space-around",
             
            //  ali

            }}>

              {/*edite  */}
              

          <EditOutlinedIcon
          onClick={()=>{handEdatitodo()}}
          className='iconbutton'
           aria-label="delete"
            size="small"
            style={{
              backgroundColor:"white",
              border:"solid blue 2px",
              marginTop:"40px", 
              // float:"right" , 

              color:"#1769aa" ,
              cursor:"pointer",
              borderRadius:"10px",
              height:"40px",
               width:"40px"

            }}
            >

          {/* icon delete */}

          </EditOutlinedIcon>         
          <IconButton
          onClick={()=>{
            handdeletetodo()
          }}
            className='iconbutton'
           aria-label="delete"
            size="small"
            style={{
              backgroundColor:"white",
              border:"solid blue 2px",
              // borderRadius:" 20px",
              padding:"-50px", 
                marginTop:"40px",
              // float:"right"   
              color:"red",
              // paddingBottom:"50px"
               borderRadius:"10px",
               height:"40px",
               width:"40px"
              
            }}
            >

              {/* cheek صح */}

          <DeleteIcon  />
          </IconButton>         
          < CheckOutlinedIcon
              onClick={()=>{
                 handalcheke()
              }}
             className='iconbutton'
             aria-label="delete"
             size="small"
             style={{
              color:"black",
              backgroundColor:todo. iscomplet?"green":"white",//iscompletهي اصلا النورمل فولس خليها خلفيه بيضاء واذا همس وهي ترو خليها اخضر ===.todo==هي الجايه من البروب منفوق 
              border:"solid blue 2px",
              marginTop:"40px", 
              // float:"right"   
               cursor:"pointer",
               height:"40px",
               width:"40px"

            }}
            >
          {/* <DeleteIcon fontSize="small" /> */}
          </ CheckOutlinedIcon>         
        </Grid>       
   </Grid>
         
</Card>        
    
  </>
  );
}